module.exports = __webpack_public_path__ + "media/images/profile_verification/victory_left-369d30c71903f1177b55e45d56f25925.png";